module.exports = __webpack_public_path__ + "static/media/status-error.6df5dcf3.svg";